<template>
    <section>
        <div class="solicitation-info">
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.city.label }}</span>
                    <span v-if="payload.city.required" class="required-field-indicator" title="Campo obrigatório">*</span>
                </div>
                <multiselect
                    v-model="payload.city.value"
                    :options="filteredCities"
                    :searchable="true"
                    :clear-on-select="true"
                    :allow-empty="true"
                    :internal-search="false"
                    placeholder="⬇️ Selecione a cidade..."
                    @search-change="searchOptions"
                    :select-label="'Clique para selecionar'"
                    :deselect-label="'Clique para remover'"
                    :selected-label="'Selecionado'"
                >
                    <span slot="noResult">
                        Nenhum resultado encontrado
                    </span>
                    <span slot="noOptions">
                        Nenhum item disponível
                    </span>
                </multiselect>
            </div>
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.place.label }}</span>
                    <span v-if="payload.place.required" class="required-field-indicator" title="Campo obrigatório">*</span>
                </div>
                <input class="form-control" placeholder="Local da ocorrência" v-model="payload.place.value">
            </div>
        </div>
        <div class="custom-input-group">
            <div>
                <span>{{ payload.description.label }}</span>
                <span v-if="payload.description.required" class="required-field-indicator" title="Campo obrigatório">*</span>
            </div>
            <textarea class="form-control" rows="3" placeholder="Descreva a reclamação..." v-model="payload.description.value"></textarea>
        </div>
        <div class="buttons-container">
            <button class="form-control" id="cancel-button" @click="cancel"><i class="fas fa-times"></i>  Descartar</button>
            <button v-if="!saving" class="form-control" id="save-button" @click="save"><i class="fas fa-save"></i>  Salvar</button>
            <button v-else class="form-control" id="save-button" disabled><i class="fas fa-spinner fa-pulse"></i>  Salvando...</button>
        </div>
    </section>
</template>

<script>
export default {
    directives: {},
    props: ['clientInfo', 'cities', 'saveLoading', 'reset'],
    components: {},
    data(){
        return {
            saving: false,
            payload: {
                city: {label: 'Cidade', value: '', required: true},
                description: {label: 'Descrição', value: '', required: true},
                place: {label: 'Local/Ponto de referência', value: '', required: true}
            },
            filteredCities: [],
        }
    },
    computed: {},
    created(){},
    mounted(){
        this.filteredCities = [...this.cities];
    },
    methods: {
        searchOptions(query) {
            const keyword = query.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            if (!keyword) {
                this.filteredCities = [...this.cities];
                return;
            }
        
            this.filteredCities = this.cities.filter((item) =>
                item.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(keyword)
            );
        },
        async save(){
            this.$emit('save', {type: 'conduta', data: this.payload})
        },
        async cancel(){
            Swal.fire({
                title: 'Descartar solicitação?',
                html: 'Deseja descartar as alterações feitas?',
                showCancelButton: true,
                confirmButtonText: 'Sim, descartar',
                cancelButtonText: 'Não, continuar editando',
                type: "question",
                showCloseButton: true,
                reverseButtons: true
            }).then(async result => {
                if(result.value) {
                    this.$emit('cancel')
                    await this.resetForm()
                }
            });
        },
        async resetForm(){
            this.payload = {
                city: {label: 'Cidade', value: '', required: true},
                description: {label: 'Descrição', value: '', required: true},
                place: {label: 'Local/Ponto de referência', value: '', required: true}
            }
        }
    },
    watch: {
        saveLoading: {
            handler(value){
                this.saving = value
            }
        },
        reset() {
            this.resetForm()
        }
    }
}
</script>

<style lang="scss" scoped>
.required-field-indicator {
    font-size: small;
    text-align: start;
    color: red;
}

.solicitation-info {
    display: flex;
    gap: 10px;
    min-height: 70px;
}
.custom-input-group {
    display: flex;
    flex-direction: column;
    text-align: start;
    width: 100%;
    justify-content: center;

    span {
        font-weight: bold;
    }

    textarea {
        resize: none
    }

    .input-with-button {
        display: flex;
        gap: 5px;
        height: 100%;
        align-items: center;

        button {
            border-radius: 10px !important;
            box-shadow: none;
        }
    }
}

.buttons-container {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    margin-bottom: 0;
    margin-top: 10px;

    button {
        width: fit-content;
        color: white;
        border-radius: 10px !important;
        box-shadow: none;
        transition: ease-in-out 0.2s
    }

    #save-button {
        background-color: darkgreen;

        &:hover {
            background-color: #023b02;
        }
    }

    #cancel-button {
        background-color: #a00404;

        &:hover {
            background-color: #6d0303;
        }
    }
}
</style>